// Highlight the active link in the table of contents on all documentation pages.
document.querySelectorAll('a[href="' + document.location.pathname + '"]')
    .forEach(function (el) { el.className += ' active' });